<template>
  <template v-if="subscriptionConsumptionPacksError">
    <AppCard elevation="0" data-locator="subscription-consumption-packs">
      <app-alert-in-page :dismissible="false"
                          variant="error"
                          no-icon
      >
        {{ $t('subscriptions.views.SubscriptionConsumption.Packs.error') }}
      </app-alert-in-page>
    </AppCard>
  </template>
  <template v-else>
    <template v-if="subscriptionConsumptionPacksPending">
      <AppCard elevation="0">
        <v-skeleton-loader type="text"/>
        <v-skeleton-loader type="text"/>
      </AppCard>
    </template>
    <template v-else-if="subscriptionConsumptionPacks">
      <AppCard
        v-for="(pack, index) in subscriptionConsumptionPacksDatas"
        :key="index"
        elevation="0"
      >
        <SubscriptionConsumptionPacksTemplate :pack="pack"
                                              :isSignaturePack="subscriptionConsumptionPacks.signatures"
                                              class="mb-5"
        >
        </SubscriptionConsumptionPacksTemplate>
      </AppCard>
    </template>
  </template>
</template>

<script>
  import { mapState, mapActions } from 'vuex'

  import AppCard from '@/common/AppCard.vue'
  import { toast } from '@/common/utils/toast'
  import { GET_SUBSCRIPTION_CONSUMPTION_PACKS } from '@/store/modules/subscription/action_types'

  import SubscriptionConsumptionPacksTemplate from './SubscriptionConsumptionPacksTemplate.vue'

  export default {
    name: 'SubscriptionConsumptionPacks',
    components: { AppCard, SubscriptionConsumptionPacksTemplate },
    computed: {
      ...mapState('subscription', [
        'subscriptionConsumptionPacksPending',
        'subscriptionConsumptionPacks',
        'subscriptionConsumptionPacksError',
      ]),
      subscriptionConsumptionPacksDatas () {
        return this.subscriptionConsumptionPacks?.envelopes || this.subscriptionConsumptionPacks?.signatures
      },
    },
    created () {
      this.getSubscriptionConsumptionPacks()
    },
    methods: {
      ...mapActions('subscription', [GET_SUBSCRIPTION_CONSUMPTION_PACKS]),
      async getSubscriptionConsumptionPacks () {
        try {
          await this.GET_SUBSCRIPTION_CONSUMPTION_PACKS()
        } catch (error) {
          toast.error(this.$t('subscriptions.views.SubscriptionConsumption.Packs.error'))
        }
      },
    },
  }
</script>
